import React, { useCallback, useEffect, useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Form,
  Input,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import { successToast } from "components/toast";
import { errorToast } from "components/toast";
import { useNavigate, useParams } from "react-router-dom";
import { getEducationDataById } from "services/_educational_resources";
import { updateEducationDataById } from "services/_educational_resources";
import { createEducationData } from "services/_educational_resources";
import TextEditor from "components/TextEditor";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CreateEducation = () => {
  const { id } = useParams();
  const [editData, setEditData] = useState({});
  const [media, setMedia] = useState({});
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/admin/educational-resource");
  };

  const handleSubmit = async (values, { resetForm }) => {
    const payload = {
      title: values.title,
      short_description: values.short_description,
      status: values.status,
      content: values.content,
      meta_title: values.meta_title,
      meta_description: values.meta_description,
      media: media,
    };

    if (id) {
      const data = await updateEducationDataById(id, payload);
      if (data.data) {
        successToast(data.message);
        resetForm();
        navigate("/admin/educational-resource");
      } else {
        errorToast(data.message);
      }
    } else {
      const data = await createEducationData(payload);
      if (data.data) {
        successToast(data.message);
        resetForm();
        navigate("/admin/educational-resource");
      } else {
        errorToast(data.message);
      }
    }
  };

  const getInitialData = useCallback(async () => {
    const data = await getEducationDataById(id);
    if (data.data) {
      setEditData(data.data);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      getInitialData();
    }
  }, [getInitialData, id]);

  const imgUrl = editData?.image_url;

  const MedicalConditionSchema = Yup.object().shape({
    title: Yup.string().required("Name is required"),
    short_description: Yup.string().optional(),
    image: Yup.mixed().nullable(),
    status: Yup.boolean().nullable(),
    content: Yup.string().required("Content is required"),
    meta_title: Yup.string().optional(),
    meta_description: Yup.string().optional(),
  });

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <Col className="order-xl-1">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">
                      <i
                        className="fas fa-arrow-left"
                        style={{ paddingRight: "10px" }}
                        onClick={handleNavigate}
                      ></i>
                      {id
                        ? "Edit Educational Resource"
                        : "Create Educational Resource "}
                    </h3>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    title: editData?.title || "",
                    short_description: editData?.short_description || "",
                    image: null,
                    status: editData?.status ?? null,
                    content: editData?.content || "",
                    meta_title: editData?.meta_title || "",
                    meta_description: editData?.meta_description || "",
                  }}
                  validationSchema={MedicalConditionSchema}
                  onSubmit={handleSubmit}
                >
                  {({ values, setFieldValue, handleChange, handleSubmit }) => (
                    <Form onSubmit={handleSubmit}>
                      <div className="pl-lg-4">
                        <Row>
                          {/* Name */}
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-name"
                              >
                                Title <span style={{ color: "red" }}>*</span>
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-title"
                                name="title"
                                placeholder="Enter title"
                                type="text"
                                value={values.title}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="title"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          {/* Short Description */}
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-short_description"
                              >
                                Short Description
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-short_description"
                                name="short_description"
                                placeholder="Enter short description"
                                type="textarea"
                                rows="4"
                                value={values.short_description}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="short_description"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="12">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-name"
                              >
                                Detailed Content
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <div className="custom-quill">
                                <TextEditor
                                  value={values.content}
                                  onChange={(val) =>
                                    setFieldValue("content", val)
                                  }
                                  placeholder="Enter detailed content..."
                                  height={400}
                                />
                              </div>
                              <ErrorMessage
                                name="content"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-meta_title"
                              >
                                Meta Title
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-meta_title"
                                name="meta_title"
                                placeholder="Enter meta title"
                                type="text"
                                value={values.meta_title}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="meta_title"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-name"
                              >
                                Meta Description
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-meta_description"
                                name="meta_description"
                                placeholder="Enter meta description"
                                type="text"
                                value={values.meta_description}
                                onChange={handleChange}
                              />
                              <ErrorMessage
                                name="meta_description"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-status"
                              >
                                Status
                              </label>
                              <Input
                                type="select"
                                id="input-status"
                                name="status"
                                className="form-control-alternative"
                                style={{
                                  boxShadow:
                                    "0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)",
                                  border: 0,
                                  color: "#90a4ae !important",
                                }}
                                value={
                                  values.status === true
                                    ? "true"
                                    : values.status === false
                                    ? "false"
                                    : ""
                                }
                                onChange={(e) =>
                                  setFieldValue(
                                    "status",
                                    e.target.value === "true" ? true : false
                                  )
                                }
                              >
                                <option value="">Select status</option>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                              </Input>
                              <ErrorMessage
                                name="status"
                                component="div"
                                className="text-danger"
                              />
                            </FormGroup>
                          </Col>

                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-image"
                              >
                                Image Upload
                              </label>
                              <Input
                                className="form-control-alternative"
                                id="input-image"
                                name="image"
                                type="file"
                                style={{
                                  color: "#90a4ae",
                                  backgroundColor: "white",
                                  boxShadow:
                                    "0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)",
                                  border: 0,
                                  height: "43px",
                                  padding: "5px 0 5px 5px",
                                  margin: "0",
                                  lineHeight: "28px",
                                  borderRadius: "5px",
                                  overflow: "hidden",
                                }}
                                onChange={(event) => {
                                  const file = event.currentTarget.files[0];
                                  if (file) {
                                    const reader = new FileReader();
                                    reader.onload = () => {
                                      const base64Raw =
                                        reader.result.split(",")[1];
                                      const fileObj = {
                                        fileName: file.name,
                                        fileData: base64Raw,
                                      };
                                      setMedia(fileObj);
                                      setFieldValue("image", file);
                                    };
                                    reader.readAsDataURL(file);
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="image"
                                component="div"
                                className="text-danger"
                              />

                              {id ? (
                                <div className="mt-2">
                                  <img
                                    src={`${BACKEND_URL}${imgUrl}`}
                                    alt="Preview"
                                    style={{
                                      width: "100px",
                                      height: "100px",
                                      objectFit: "cover",
                                      borderRadius: "8px",
                                    }}
                                  />
                                </div>
                              ) : (
                                ""
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>

                      {/* Submit */}
                      <div className="pl-lg-4">
                        <Button color="primary" type="submit">
                          Save
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default CreateEducation;
